<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /** Имя файла из src/assets/icons без расширения */
  name: string
  /** Размер стороны, px */
  size?: number
}

const props = defineProps<Props>()

/*
 * Иконки экспортированы из макета (tools/fig/export_icon.py) и инлайнятся,
 * чтобы работал currentColor. v-html безопасен: только статические ассеты
 * сборки, пользовательские данные сюда не попадают.
 */
const icons = import.meta.glob<string>('@/assets/icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
})

const svg = computed(() => {
  const entry = Object.entries(icons).find(([path]) => path.endsWith(`/${props.name}.svg`))
  return entry?.[1] ?? ''
})

const px = computed(() => `${props.size ?? 24}px`)
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span class="app-icon" :style="{ width: px, height: px }" v-html="svg" />
</template>

<style scoped lang="scss">
.app-icon {
  display: inline-flex;
  flex-shrink: 0;

  :deep(svg) {
    width: 100%;
    height: 100%;
  }
}
</style>
